exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feather-icon{display:inline-flex;align-items:center}", ""]);

// exports
